import { CoreIcon } from '../core-icon';
import statsSVG from '../../../src/images/icons/stats.svg';

export const StatsIcon = props => {
  return <CoreIcon src={statsSVG} {...props} />;
};
